export default __webpack_public_path__ + "static/media/icon-opening.81e1a13e.svg";